
// countdown (announcement bar)
(function(){
  var KEY='cabn_fd_deadline',PERIOD=12*3600*1000,now=Date.now();
  var stored='0';
  try{stored=localStorage.getItem(KEY)||'0';}catch(e){}
  var dl=parseInt(stored,10);
  if(!dl||dl-now>PERIOD){dl=now+PERIOD;}
  else if(dl<=now){dl+=Math.floor((now-dl)/PERIOD+1)*PERIOD;}
  try{localStorage.setItem(KEY,dl);}catch(e){}
  var els=document.querySelectorAll('.cb-timer');
  function tick(){var current=Date.now(),d=dl-current;if(d<=0){dl+=PERIOD;if(dl<=current)dl=current+PERIOD;try{localStorage.setItem(KEY,dl);}catch(e){}d=dl-current;}var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);var t=(h<10?'0':'')+h+'h '+(m<10?'0':'')+m+'m '+(s<10?'0':'')+s+'s';els.forEach(function(e){e.textContent=t;});}
  tick();setInterval(tick,1000);
})();
// reveal on scroll
(function(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
})();
// counter 0 -> 80
(function(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var el=e.target,to=parseInt(el.getAttribute('data-to'),10),st=Date.now(),dur=1300;(function step(){var p=Math.min(1,(Date.now()-st)/dur);el.textContent=Math.round(to*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(step);})();io.unobserve(el);}});},{threshold:.6});
  document.querySelectorAll('.cnt').forEach(function(el){io.observe(el);});
})();
// sticky cta appears after hero
(function(){
  var sticky=document.getElementById('sticky'),hero=document.querySelector('.hero');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('show',!e.isIntersecting);});},{threshold:0});
  io.observe(hero);
})();
